import React  from 'react';
import BooleanComponentProto from './boolean-proto.jsx';


export default function renderBooleanInList(id, props) {
    return <BooleanComponentProto renderMode="list" id={id} {...props} />;
}